/** Machine reason_codes → Thai queue copy (mirrors billlin-agent reason_labels). */
const REASON_LABELS_TH: Record<string, string> = {
  no_confident_match: "ยังไม่เจอยอดที่มั่นใจพอ",
  no_counterpart: "ยังไม่มีรายการฝั่งตรงข้ามให้จับคู่",
  ambiguous_candidates: "มีหลายรายการใกล้เคียงกัน ต้องเลือก",
  amount_match: "ยอดเงินตรงกัน",
  hint_match: "มีคำใบ้/ชื่อผู้โอนตรง",
  alias_match: "ชื่อเล่น/นามแฝงตรงกัน",
  alias_without_prefix: "ชื่อตรงกัน (ตัดคำนำหน้า)",
  alias_partial: "ชื่อตรงกันบางส่วน",
  single_slip: "มีสลิปเดียวที่เข้าเกณฑ์",
  expense_receipt_received: "รับใบเสร็จค่าใช้จ่ายแล้ว",
  expense_note_received: "รับรายการค่าใช้จ่ายแบบข้อความแล้ว",
  retro_suggested: "ระบบแนะนำให้จับคู่ย้อนหลัง",
  retro_rejected: "ปฏิเสธการจับคู่ที่แนะนำ",
  split_suggested: "ระบบแนะนำให้แบ่งยอด",
  fifo_oldest_first: "ปิดยอดเก่าก่อน",
};

export function reasonLabelTh(code: string): string {
  const key = code.trim();
  if (!key) return "";
  return REASON_LABELS_TH[key] ?? key;
}

/** Translate a subtitle that may be one code or several joined with · */
export function translateReasonSubtitle(raw: string | null | undefined): string {
  const text = String(raw ?? "").trim();
  if (!text) return "";
  return text
    .split(/\s*·\s*/)
    .map((part) => reasonLabelTh(part.trim()))
    .filter(Boolean)
    .join(" · ");
}
